import { useFlags } from 'launchdarkly-react-client-sdk';
import { SsmUiFlagsTypes } from '@utilities/hooks/useSsmUiFlags/SsmUiFlags.types';

export function useSsmUiFlags() {
	return useFlags<SsmUiFlagsTypes>();
}

